
export default class ObjectCache {
  static #weakMap = new WeakMap()
  static MAX_CACHE_ENTRIES = 100

  /**
   *
   * @param {object} obj
   * @returns {ObjectCache}
   */
  static get (obj) {
    let cache = this.#weakMap.get(obj)

    if (!cache) {
      cache = new ObjectCache()
      this.#weakMap.set(obj, cache)
    }

    return cache
  }

  #map = new Map()
  #calls = 0
  #now
  #hits = 0
  #misses = 0

  constructor (cacheToClone) {
    this.#now = globalThis.performance ? globalThis.performance.now() : Date.now()

    if (cacheToClone !== undefined) {
      let i = 0
      for (const entry of cacheToClone.entries()) {
        if (++i > ObjectCache.MAX_CACHE_ENTRIES) break
        this.#map.set(...entry)
      }
    }
  }

  entries () {
    return this.#map.entries()
  }

  keys () {
    return this.#map.keys()
  }

  clear () {
    return this.#map.clear()
  }

  get (key) {
    ++this.#calls
    const result = this.#map.get(key)
    if (result !== undefined) {
      ++this.#hits
      // this.report()
    } else {
      ++this.#misses
    }

    return result
  }

  set (key, value) {
    if (this.#map.size >= ObjectCache.MAX_CACHE_ENTRIES) {
      return this
    }

    this.#map.set(key, value)
    // this.report()
    return this
  }

  report () {
    if (this.#calls === 0) return
    const ms = (globalThis.performance ? globalThis.performance.now() : Date.now()) - this.#now
    const hitRate = ((100 * this.#hits) / this.#calls).toFixed(0)
    console.log(`${this.#calls} calls in ${ms.toFixed(2)}ms. Hits: ${this.#hits} (${hitRate}%). Misses: ${this.#misses}.`)
  }
}
